import React from 'react';

import Html from '~/commons/components/Html.jsx';
import Modal from '~/commons/components/Modal.jsx';
import ExtraReading from '../blocks/ExtraReading.jsx';

const ModalAnsRes = ({
  answer,
  extraReading,
  keyLearning,
  show,
  onHide,
  onExtraRead,
}) => (
  <Modal
    size="lg"
    show={show}
    onHide={onHide}
    centered
    className="p-0"
  >
    <div className="container-fluid">
      <div className="row py-4 justify-content-center">
        <div className="col-12 col-sm-8 text-center">
          <h3>恭喜你提交成功</h3>
          {/* <p>
            本次回答獲得 {answer && answer.score}分
            <br />
            現在可以回到文章查看正確答案
          </p> */}
          <button
            onClick={onHide}
            className="btn btn-secondary"
          >
            回到文章
          </button>
        </div>
      </div>
      {keyLearning && (
        <div className="bg-light row py-4 justify-content-center">
          <div className="col-12 col-sm-8">
            <h4 className="mb-3">
              <img
                className="mt-n1 mr-2"
                src="/assets/img/key-learning.svg"
                style={{ width: '28px' }}
              />
              詞句一分鐘
            </h4>
            <Html>{keyLearning}</Html>
          </div>
        </div>
      )}
      {extraReading && extraReading.url && (
        <div className="bg-paper row py-4 justify-content-center">
          <div className="col-12 col-sm-8">
            <ExtraReading
              tips
              onExtraRead={(score) => {
                onExtraRead(score);
                onHide();
              }}
              extraReading={extraReading}
              answer={answer}
            />
          </div>
        </div>
      )}
    </div>
  </Modal>
);

export default ModalAnsRes;
